import 'moment-timezone';
import React from 'react';
import ReactKeymaster from 'react-keymaster';
import Moment from 'react-moment';
import {connect} from 'react-redux';
import {
  setPlaySpeed,
  setTimelineToNow,
  startTimelineDrag,
  stopPlaying,
  stopTimelineDrag,
  togglePlaying,
  toggleTimelineHistory
} from '../actions';
import {OVERLAY_KEYS} from '../Constants';
import {updateTimeOrchestrator} from '../orchestrators';
import {incidentPrescriptionsLayerIsActive} from '../utils/prescriptions_utils';

import {addDays, formatTime, lastMidnightDate} from '../utils/time_utils';

import './TemporalNavigator.css';

class TemporalNavigator extends React.Component {

  render() {
    const {
      dispatch,
      indicators,
      time,
      play,
      loaded_times,
      dragging,
      show_history,
      active_overlays,
      incident_layers,
      wind_data
    } = this.props;

    const active_indicator = indicators.active;
    const showingWindData = this.showingWindData(active_overlays);
    const showingPrescriptions = incidentPrescriptionsLayerIsActive(incident_layers);
    const tempNavigator = (active_indicator || showingWindData || showingPrescriptions) ?
                          <div className="c-temporal-navigator h-shadow-border">
                            <div className="c-temporal-navigator__controls">
                              {this.renderControls(dispatch, time, active_indicator, play)}
                            </div>
                            {this.renderTimeRange(dispatch, time, active_indicator, loaded_times, dragging,
                              show_history, showingWindData, wind_data)}
                          </div> : null;

    return (
      <div className="c-temporal-navigator-container">
        {tempNavigator}
      </div>
    );
  }

  renderTimeRange(dispatch, time, active_indicator, loaded_times, dragging, show_history, showingWindData, wind_data) {
    const days = [];
    const dayStart = lastMidnightDate(new Date());
    return (
      <div className={'c-temporal-navigator__container'}>
        <div className="timeline-controls">
          <div className="buttons">
            <div className="c-button icon-only"
                 onClick={() => {
                   dispatch(setTimelineToNow());
                   this.refs.timeLine.scrollLeft = 0;
                 }}
                 title="Now">
              <i className="far fa-clock"/>
            </div>
          </div>
          <div className="buttons history-toggle">
            <div className={'c-button icon-only' + (show_history ? ' selected' : '')}
                 onClick={() => dispatch(toggleTimelineHistory())}
                 title={(show_history ? 'Hide' : 'Show') + ' 2 day history'}>
              <i className="fa fa-history"/>
            </div>
          </div>
        </div>
        <div className="c-temporal-navigator__time-range" ref="timeLine">
          <div className="c-time-range">
            {
              time.valid_times.map((value) => {
                let date = new Date(value);
                let historical = dayStart > date;
                if (historical && !show_history) {
                  return null;
                }
                let hour = date.getHours();
                let active = (value === time.selected_time);
                let displayed = (value === time.display_time);
                let display_time = undefined;
                let content = [];
                let container_class_names = [];
                if (hour === 0) {
                  let active_day_class_name = '';
                  if (new Date(time.selected_time).getDate() === date.getDate()) {
                    active_day_class_name = 'c-day-range__day--active';
                  }
                  days.push(<p className={'c-day-range__day ' + active_day_class_name}
                               key={'day-' + value}><Moment tz="Australia/Melbourne"
                                                            format="ddd DD/MM">{value}</Moment></p>);
                  container_class_names.push('is-new-day');
                } else if (hour === 6 || hour === 12 || hour === 18) {
                  container_class_names.push('is-highlight');
                }

                if (active_indicator && active_indicator.available_times) {
                  let available_time_index = active_indicator.available_times.contained_points[value];
                  if (available_time_index !== undefined) {
                    container_class_names.push('is-available');
                    let interval = active_indicator.available_times.intervals[available_time_index];
                    display_time = interval.point_at;
                    if (value === interval.contained_periods[0]) {
                      container_class_names.push('is-start');
                    }
                    if (value === interval.contained_periods[(interval.contained_periods.length - 1)]) {
                      container_class_names.push('is-end');
                    }
                    if (loaded_times.includes(value)) {
                      container_class_names.push('loaded');
                    }
                    if (historical) {
                      container_class_names.push('historical');
                    }
                  }
                } else if (showingWindData) {
                  container_class_names.push('is-available is-start is-end');
                }

                if (showingWindData && wind_data.magnitude_data[value] && wind_data.direction_data[value]) {
                  container_class_names.push('wind-loaded');
                }

                if (active) {
                  content.push(<span className="c-temporal-navigator__selector"
                                     key="temporal-navigator-selector"/>);
                  content.push(<div id="selected-time"
                                    className="c-time-range__selected"
                                    key="temporal-navigator-selected-date">
                    <Moment tz="Australia/Melbourne" format="HH:mm">{value}</Moment></div>);
                }

                if (displayed) {
                  container_class_names.push('is-displayed');
                }

                let container_class_string = '';
                container_class_names.forEach(
                  (className) => container_class_string = container_class_string + className + ' ');

                return (
                  <div className={'c-time-range__point ' +
                                  container_class_string +
                                  (active ? 'is-active' : 'is-inactive')}
                       key={value}
                       onClick={() => {
                         dispatch(stopPlaying());
                         dispatch(updateTimeOrchestrator(value, display_time));
                       }}
                       title={formatTime(value)}>
                    <div className={'timeline-dnd-interceptor'}
                         onDragOver={dragging ? () => dispatch(updateTimeOrchestrator(value, display_time)) : null}
                         draggable={true}
                         onDragStart={() => dispatch(startTimelineDrag())}
                         onDragEnd={() => dispatch(stopTimelineDrag())}/>
                    {content}
                    <span className="c-time-range__hour"/>
                  </div>
                );
              })
            }
          </div>
          <div className="c-day-range">
            {
              days.map((value) => value)
            }
          </div>
        </div>
      </div>
    );
  }

  renderControls(dispatch, time, active_indicator, play) {
    const next_day_time = addDays(new Date(time.selected_time), 1);
    const previous_day_time = addDays(new Date(time.selected_time), -1);

    return (
      <div className="c-temporal-controls">
        <React.Fragment>
          <ReactKeymaster keyName="space" onKeyDown={
            () => {
              dispatch(togglePlaying());
              return false;
            }
          }/>
          <ReactKeymaster keyName="left" onKeyDown={
            () => {
              if (previous_day_time) {
                dispatch(updateTimeOrchestrator(previous_day_time));
              }
              return false;
            }
          }/>
          <ReactKeymaster keyName="right" onKeyDown={
            () => {
              if (next_day_time) {
                dispatch(updateTimeOrchestrator(next_day_time));
              }
              return false;
            }
          }/>
        </React.Fragment>
        <div className="section main">
          <div className={'fa ' + (play.playing ? 'fa-pause' : 'fa-play') + ' control'}
               role="img" aria-label="play" onClick={() => { dispatch(togglePlaying()); }}/>
        </div>
        {play.playing ?
         this.renderSpeedControls(dispatch, play.speed) :
         this.renderSkipControls(dispatch, previous_day_time, next_day_time)}
      </div>
    );
  }

  renderSpeedControls(dispatch, speed) {
    return (
      <div className="section secondary">
        <div className={'speed control' + (speed === 1 ? ' selected' : '')}
             onClick={() => dispatch(setPlaySpeed(1))}
             aria-label="Speed 1">
          <div className="fas fa-angle-right"/>
        </div>
        <div className={'speed control' + (speed === 2 ? ' selected' : '')}
             onClick={() => dispatch(setPlaySpeed(2))}
             aria-label="Speed 2">
          <div className="fas fa-angle-right"/>
          <div className="fas fa-angle-right"/>
        </div>
        <div className={'speed control' + (speed === 3 ? ' selected' : '')}
             onClick={() => dispatch(setPlaySpeed(3))}
             aria-label="Speed 3">
          <div className="fas fa-angle-right"/>
          <div className="fas fa-angle-right"/>
          <div className="fas fa-angle-right"/>
        </div>
      </div>
    );
  }

  renderSkipControls(dispatch, previous_day_time, next_day_time) {
    return (
      <div className="section secondary">
        <div className="fa fa-fast-backward control" aria-label="skip back one day" onClick={
          () => {
            if (previous_day_time) {
              dispatch(updateTimeOrchestrator(previous_day_time));
            }
          }
        }/>
        <div className="fa fa-fast-forward control" aria-label="skip forwards one day" onClick={
          () => {
            if (next_day_time) {
              dispatch(updateTimeOrchestrator(next_day_time));
            }
          }
        }/>
      </div>
    );
  }

  showingWindData = (overlays) => overlays[OVERLAY_KEYS.WIND_ANIMATED] === true ||
                                  overlays[OVERLAY_KEYS.WIND_BARBS] === true;
}

const mapStateToProps = state => {
  return {
    indicators: state.indicators,
    time: state.time,
    play: state.play,
    loaded_times: state.indicator_overlays.loaded_times,
    dragging: state.timeline_dnd.dragging,
    show_history: state.timeline.show_history,
    active_overlays: state.overlays.active,
    incident_layers: state.incidents.layers,
    wind_data: state.wind_data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

TemporalNavigator = connect(mapStateToProps, mapDispatchToProps)(TemporalNavigator);

export default TemporalNavigator;



// WEBPACK FOOTER //
// ./src/containers/TemporalNavigator.js